import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

const GLOBAL_COMMUNITY_ID = '9999'
const SCOPE_TYPE_GLOBAL = 'GLOBAL'
const SCOPE_TYPE_COMMUNITY = 'COMMUNITY'

function normalizeAdvertPayload(data = {}) {
  const payload = { ...data }
  payload.clientType = !payload.clientType ? 'ALL' : String(payload.clientType).trim().toUpperCase()
  payload.positionType = !payload.positionType ? 'ALL' : String(payload.positionType).trim().toUpperCase()
  payload.pageUrl = payload.advertType === '3' ? '' : String(payload.pageUrl || '').trim()
  payload.seq = String(payload.seq || '').trim()

  if (payload.scopeType === SCOPE_TYPE_GLOBAL || payload.communityId === GLOBAL_COMMUNITY_ID) {
    payload.scopeType = SCOPE_TYPE_GLOBAL
    payload.communityId = GLOBAL_COMMUNITY_ID
    return payload
  }

  payload.scopeType = SCOPE_TYPE_COMMUNITY
  payload.communityId = payload.communityId || getCommunityId()
  return payload
}

// 获取广告列表
export function listAdverts(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/advert.listAdverts',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
        resolve({
          data: res.adverts || [],
          total: Number(res.total || 0),
          managementMode: res.managementMode || 'PLATFORM',
          canPublishGlobal: res.canPublishGlobal === true
        })
    }).catch(error => {
      reject(error)
    })
  })
}

// 添加广告
export function saveAdvert(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/advert.saveAdvert',
      method: 'post',
      data: normalizeAdvertPayload(data)
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || 'Failed to save advertisement'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新广告
export function updateAdvert(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/advert.updateAdvert',
      method: 'post',
      data: normalizeAdvertPayload(data)
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || 'Failed to update advertisement'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除广告
export function deleteAdvert(advertId) {
  return new Promise((resolve, reject) => {
    request({
      url: '/advert.deleteAdvert',
      method: 'post',
      data: { advertId }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || 'Failed to delete advertisement'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 上传文件
export function uploadFile(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/uploadFile',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res.data)
      } else {
        reject(new Error(res.msg || 'Failed to upload file'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
// 获取广告详情
export function getAdvertDetail(advertId) {
  return new Promise((resolve, reject) => {
    request({
      url: '/advert.getAdvertDetail',
      method: 'get',
      params: { advertId }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res.data)
      } else {
        reject(new Error(res.msg || 'Failed to get advertisement detail'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取广告项列表
export function getAdvertItems(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/advert.listAdvertItems',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
        resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取位置类型
export function getLocationTypes() {
  return new Promise((resolve, reject) => {
    request({
      url: '/dict.listDict',
      method: 'get',
      params: { type: 'location_type_cd' }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res.data)
      } else {
        reject(new Error(res.msg || 'Failed to get location types'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
